import {
  GET_TEMPLATE_BY_ID,
  GET_TEMPLATE_BY_ID_SUCCESS,
  GET_TEMPLATE_BY_ID_ERROR,
  GET_TEMPLATE_BY_ID_EMPTY,
} from '../../../actions';

const initialState = {
  data: null,
  message: null,
  loading: false,
  success: false,
  error: false,
};

const GetTemplateById = (state = initialState, action) => {
  switch (action.type) {
    case GET_TEMPLATE_BY_ID:
      state = {
        ...state,
        // data: null,
        loading: true,
        success: false,
        error: false,
        message: null,
      };
      break;

    case GET_TEMPLATE_BY_ID_SUCCESS:
      state = {
        ...state,
        data: action.payload,
        loading: false,
        success: true,
        error: false,
        message: null,
      };
      break;

    case GET_TEMPLATE_BY_ID_ERROR:
      state = {
        ...state,
        data: null,
        loading: false,
        success: false,
        error: true,
        message: action.payload,
      };
      break;

    case GET_TEMPLATE_BY_ID_EMPTY:
      state = {
        ...initialState,
      };
      break;

    default:
      state = { ...state };
      break;
  }
  return state;
};

export default GetTemplateById;
